import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { loginUser } from "../../actions/authActions";
import { subscriberUser } from "../../actions/authActions";
import Login from "../../components/auth/Login";
import Header from "../../components/pages/Header";
import Register from "../../components/auth/Register";
import SubscribeUser from "../../components/auth/SubscribeUser";
import ForgetPassword from "../../components/auth/ForgetPassword";
import Footer from "../../components/pages/Footer";
import {toast,Toaster } from 'react-hot-toast';
import Loading from "../layout/Loading";
import * as myConstList from '../../BaseUrl';
import MetaTags from 'react-meta-tags';
import axios from "axios";
import Scroll from 'react-scroll';
import $ from 'jquery';
import {Modal,Button } from 'react-bootstrap';


const Link = Scroll.Link;

const baseUrl = myConstList.baseUrl;
class Home extends Component {
    constructor() {
        super();
        this.state = {         
            balance:'',
           errors: {},
           showLogin:true,
           modalIsLoadingOpen: true,
           urltemp:"",
        };
		
		this.button = React.createRef();
		this.signupTabBtn = React.createRef();
     
    }

    componentDidMount() { 
        const params = new Proxy(new URLSearchParams(this.props.history.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
          });
          let source = params.source;
          let theme = params.theme; 
          if(source==='mobile'){
            this.setState({appview:false});
          }
          if(source==='mobile' && theme==='d'){
              $('body').addClass('darkclass');
          }else{
              $('body').removeClass('darkclass');
          }       
        if (this.props.auth.isAuthenticated) { 
            if(localStorage.getItem("source") !== "" && localStorage.getItem("theme") !== ""){
                const urltemp = "?source="+localStorage.getItem("source")+"&theme="+localStorage.getItem("theme");
                this.setState({urltemp:urltemp});
                this.props.history.push("/dashboard"+urltemp);
            }else{
                this.props.history.push("/dashboard");
            }          
        }
		if(this.props.match.params.refer!==undefined){
			// this.button.current.click();
			this.signupTabBtn.current.click();
			
		}
		
    };

    componentWillReceiveProps(nextProps) {
        const urltemp = "?source="+localStorage.getItem("source")+"&theme="+localStorage.getItem("theme");
        if (nextProps.auth.isAuthenticated) {
           window.location = "/dashboard"+urltemp;
        }
        if (nextProps.errors) {
            this.setState({
                errors: nextProps.errors
            });
        }        
    }
    onSubmit = e => {
        e.preventDefault();	
            const newUser = {
            name: this.state.name,
            email: this.state.email,
            mobile: this.state.mobile
        };
        let res = this.props.subscriberUser(newUser);   
    }

render() {
        const { errors } = this.state;
        return (
            <>	
                <Login />
            { this.state.modalIsLoadingOpen &&
                <Loading />
            }
            <ForgetPassword />
            <Toaster position="bottom-right" reverseOrder={false}/>
</>
        );
    }
}

Home.propTypes = {
    loginUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});
export default connect(
    mapStateToProps,
    { loginUser }
)(Home);
